"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateFields = exports.useApiFetch = exports.useApiDelete = exports.useApiPut = exports.useApiPost = exports.useApiPatch = exports.useApiGet = void 0;
const react_1 = require("react");
const api_1 = __importStar(require("../lib/api"));
function useApiGet(path) {
    const _a = useApiFetch(api_1.FetchMethod.Get, path), { fetchApi } = _a, params = __rest(_a, ["fetchApi"]);
    return Object.assign(Object.assign({}, params), { get: fetchApi });
}
exports.useApiGet = useApiGet;
function useApiPatch(path) {
    const _a = useApiFetch(api_1.FetchMethod.Patch, path), { fetchApi } = _a, params = __rest(_a, ["fetchApi"]);
    return Object.assign(Object.assign({}, params), { patch: fetchApi });
}
exports.useApiPatch = useApiPatch;
function useApiPost(path) {
    const _a = useApiFetch(api_1.FetchMethod.Post, path), { fetchApi } = _a, params = __rest(_a, ["fetchApi"]);
    return Object.assign(Object.assign({}, params), { post: fetchApi });
}
exports.useApiPost = useApiPost;
function useApiPut(path) {
    const _a = useApiFetch(api_1.FetchMethod.Put, path), { fetchApi } = _a, params = __rest(_a, ["fetchApi"]);
    return Object.assign(Object.assign({}, params), { put: fetchApi });
}
exports.useApiPut = useApiPut;
function useApiDelete(path) {
    const _a = useApiFetch(api_1.FetchMethod.Delete, path), { fetchApi } = _a, params = __rest(_a, ["fetchApi"]);
    return Object.assign(Object.assign({}, params), { del: fetchApi });
}
exports.useApiDelete = useApiDelete;
var FetchActions;
(function (FetchActions) {
    FetchActions[FetchActions["Init"] = 0] = "Init";
    FetchActions[FetchActions["Success"] = 1] = "Success";
    FetchActions[FetchActions["Failure"] = 2] = "Failure";
})(FetchActions || (FetchActions = {}));
function fetchReducer(state, action) {
    switch (action.type) {
        case FetchActions.Init:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: undefined });
        case FetchActions.Success:
            return Object.assign(Object.assign({}, state), { isLoading: false, data: action.payload });
        case FetchActions.Failure:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        default:
            throw new Error('Unrecognized action');
    }
}
function useApiFetch(method, path) {
    const [response, setResponse] = (0, react_1.useState)();
    const [request, setRequest] = (0, react_1.useState)();
    const [state, dispatch] = (0, react_1.useReducer)(fetchReducer, { isLoading: false });
    (0, react_1.useEffect)(() => {
        if (request) {
            const processRequest = () => __awaiter(this, void 0, void 0, function* () {
                dispatch({ type: FetchActions.Init });
                try {
                    const result = yield request.response;
                    const json = yield result.json();
                    setResponse(result);
                    if (result.ok) {
                        dispatch({
                            type: FetchActions.Success,
                            payload: parseDateFields(json)
                        });
                    }
                    else {
                        dispatch({ type: FetchActions.Failure, payload: json });
                    }
                }
                catch (error) {
                    if ((error === null || error === void 0 ? void 0 : error.name) !== 'AbortError') {
                        // ignore when request is aborted
                        dispatch({ type: FetchActions.Failure, payload: error });
                    }
                }
            });
            processRequest();
            // return request.abort; // NOTE: This causes data loss; TODO: rework abort logic
        }
    }, [request]);
    const fetchApi = (0, react_1.useCallback)((params = {}) => {
        setResponse(undefined);
        setRequest(api_1.default.fetch(method, path, params));
    }, [setRequest, method, path]);
    return {
        data: state.data,
        isLoading: state.isLoading,
        response,
        error: state.error,
        fetchApi
    };
}
exports.useApiFetch = useApiFetch;
const DATE_STRING_REGEX = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
/**
 * Recursively checks the response json object for Date properties in string format and parses them to native JS Date type
 * @param json
 */
function parseDateFields(json) {
    if (json === null || json === undefined) {
        return json;
    }
    if (Array.isArray(json)) {
        return json.map(item => parseDateFields(item));
    }
    if (typeof json === 'object') {
        const newJson = {};
        Object.keys(json).forEach((key) => {
            newJson[key] = parseDateFields(json[key]);
        });
        return newJson;
    }
    if (typeof json === 'string' && DATE_STRING_REGEX.test(json)) {
        return new Date(json);
    }
    return json;
}
exports.parseDateFields = parseDateFields;
//# sourceMappingURL=Api.hooks.js.map